<template>
    <v-footer class="tdj-footer">
        <v-card flat tile class="text-center tdj-footer-card" style="background-color: #5c6bc0; width: 100%;">

            <div class="footer_player">
                <bottom-player :bottom_margin="66" />
            </div>

            <hr class="tdj-footer-divider">

            <v-card-text class="tdj-footer-text" style="padding-top: 0px; line-height: 22px;">
            &copy; 2018-{{ new Date().getFullYear() }} <strong>tangodj.online</strong>, <a href="/pages/privacy/" target="_blank" style="color:white">политика приватности</a>
            <span class="tdj-footer-version">fe: {{ frontend_commit }} · be: {{ backend_commit }}</span>
            </v-card-text>
        </v-card>
    </v-footer>
</template>
<script>

    import axios from "axios";
    import BottomPlayer from "@/components/player/BottomPlayer";

  export default {
        name: 'Footer',

        components: {BottomPlayer},

        data() {
            return {
                // Baked in at Docker build time by Dockerfile - see the
                // comment there. Falls back to 'dev' for anyone running
                // `npm run serve`/`build` outside that image, where the
                // env var was never set.
                frontend_commit: process.env.VUE_APP_GIT_COMMIT_SHORT || 'dev',
                backend_commit: '...',
            }
        },

        created() {
            this.fetchBackendCommit()
        },

        methods: {
            fetchBackendCommit() {
                // be/version/ is public and unauthenticated (see
                // common/views.py on the backend) specifically so this can
                // run before/without login.
                axios.get('/be/version/').then(result => {
                    this.backend_commit = result.data.commit
                }).catch(error => {
                    console.error(error)
                    this.backend_commit = '?'
                })
            }
        }

    }

</script>
<style lang="less">

    body.modal-open .footer_player {
        display: none;
    }

    // Vuetify 3's <v-footer absolute>/<v-card>'s old color-helper classes
    // (indigo/lighten-1/white--text) and standalone `absolute` positioning
    // only work when the app root is wrapped in <v-app>, which this app
    // doesn't do. Rather than pull in that whole layout system for one
    // footer, position and color it explicitly here.
    //
    // v-footer also ships its own 8px/16px padding and a theme-driven
    // background (--v-theme-surface) that shows through around the child
    // card - with the old theme="dark" prop that background was near-black,
    // which is what was showing up as a "thick black border" framing the
    // indigo card. Zeroing the padding and matching the background removes
    // that frame instead of fighting Vuetify's theme system for it.
    .tdj-footer {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        padding: 0;
        background-color: #5c6bc0;
    }

    .tdj-footer-text, .tdj-footer-card {
        color: white;
    }

    // Small and muted so it doesn't compete with the copyright line it
    // rides along with - this is a debugging aid (which commit is
    // actually deployed here), not user-facing content.
    .tdj-footer-version {
        display: block;
        margin-top: 2px;
        font-size: 11px;
        opacity: 0.6;
    }

    // Plain <hr>, styled by hand instead of <v-divider>, so it doesn't
    // depend on Vuetify's runtime-injected theme stylesheet. The old
    // `hr.v-divider { margin-top: 10px; }` override only ever touched the
    // top margin - the 16px margin-bottom that actually separates it from
    // the copyright text below came from Vuetify 2's own default v-divider
    // spacing, which this replacement never had, closing that gap entirely.
    .tdj-footer-divider {
        margin: 10px 0 16px 0;
        border: 0;
        border-top: 1px solid rgba(255, 255, 255, 0.3);
        height: 0;
    }

    footer {
        /*box-shadow: 0px 0px 2px rgb(0, 0, 0, 0.5);*/
    }

</style>